import React, { useEffect, useContext } from 'react';
import styles from './CustomPopup.module.css';
import { LanguageContext } from '../../Component/LanguageContext/LanguageContext';

const CustomPopup = ({ message, onConfirm, onCancel, isConfirmation = false }) => {
  const { direction } = useContext(LanguageContext);

  useEffect(() => {
    if (!isConfirmation) {
      const timer = setTimeout(() => {
        onConfirm();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [onConfirm, isConfirmation]);

  return (
    <div className={styles.popupOverlay}>
      <div className={`${styles.popupContent} ${!isConfirmation ? styles.autoClose : ''}`}>
        <p>{message}</p>
        {isConfirmation && (
          <div className={styles.buttonContainer}>
            <button className={styles.confirmButton} onClick={onConfirm}>
              {direction === 'rtl' ? 'تأكيد' : 'Confirm'}
            </button>
            <button className={styles.cancelButton} onClick={onCancel}>
              {direction === 'rtl' ? 'إلغاء' : 'Cancel'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomPopup; 